<template>
  <div class="mobile-nav d-xxl-none d-xl-none mt-3">
    <a class="btn btn-primary" data-bs-toggle="offcanvas" href="#sidebarMenu" role="button" aria-controls="sidebarMenu">
      <i class="bi bi-list"></i> Menu
    </a>
  </div>

  <div id="sidebarMenu"
    class="col-md-3col-lg-2 col-xxl-2 col-xl-3 d-md-block bg-white sidebar h-100 shadow-sm border-end offcanvas offcanvas-start"
    tabindex="-1">
    <div class="offcanvas-header">
      <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="position-sticky pt-3 offcanvas-body">
      <ul class="nav flex-column">
        <side-bar-nav-item :itemView="GuiidePlusView.Dashboard" :selectedView="selectedView" text="Dashboard"
          iconClass="bi-speedometer" data-bs-dismiss="offcanvas" @click="onItemClick(GuiidePlusView.Dashboard)" />

        <side-bar-nav-item v-show="showHome" :selectedView="selectedView" text="Home" :transitory-only="true" iconClass="bi-house"
          @click="onUserHomeClick()" />

        <side-bar-nav-item v-show="showMainJourney" :selectedView="selectedView" text="Main journey" :transitory-only="true" iconClass="bi-window"
          @click="onMainJourneyClick()" />
      </ul>

      <hr />

      <ul class="nav flex-column">
        <template v-for="menuItem in allMenuPresenationInfo" :key="menuItem.view">
          <side-bar-nav-item v-if="menuItem.item.visible" :item-view="menuItem.view" :selected-view="selectedView"
            :text="getMenuLabel(menuItem.text, menuItem.item.customLabel)" :icon-class="menuItem.iconClass" data-bs-dismiss="offcanvas"
            @click="onItemClick(menuItem.view)">
          </side-bar-nav-item>
        </template>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import GuiidePlusView from "@/guiide/ts/guiideplus/guiidePlusView";
import SideBarNavItem from "@/guiide/components/guiideplus/SideBarNavItem.vue";
import { MenuItem } from "@/guiide/ts/configuration/menuItem";
import { useStore } from "vuex";

const props = defineProps({
  selectedView: { default: GuiidePlusView.Dashboard }
});

const emit = defineEmits<{ (e: 'item-selected', value: GuiidePlusView): void }>();

const store = useStore();

const showHome = computed<boolean>(() => store.state.configuration.nav.guiidePlus.home.visible);
const showMainJourney = computed<boolean>(() => store.state.configuration.nav.guiidePlus.mainJourney.visible);
const providersText = computed<string>(() => store.state.configuration.providersShowsRetailers ? "Providers" : "Cost Comparison");

type MenuItemPresentationInfo = { item: MenuItem, text: string, iconClass: string, view: GuiidePlusView };
const allMenuPresenationInfo = computed<Array<MenuItemPresentationInfo>>(() => {
    const menuItems = [
      { item: store.state.configuration.nav.guiidePlus.pensionManagement, view: GuiidePlusView.PensionManagement, text: "[Product Name]", iconClass: "bi-robot text-success" },
      { item: store.state.configuration.nav.guiidePlus.providers, view: GuiidePlusView.Providers, text: providersText.value, iconClass: "bi-piggy-bank" },
      { item: store.state.configuration.nav.guiidePlus.advisers, view: GuiidePlusView.Advisers, text: "Advisers", iconClass: "bi-signpost-2" },
      { item: store.state.configuration.nav.guiidePlus.guaranteedIncome, view: GuiidePlusView.GuaranteedIncome, text: "Guaranteed income", iconClass: "bi-shield-check" },
      { item: store.state.configuration.nav.guiidePlus.statePensionHelp, view: GuiidePlusView.StatePensionHelp, text: "State Pension help", iconClass: "bi-flag" },
      { item: store.state.configuration.nav.guiidePlus.benefitsAndCredits, view: GuiidePlusView.BenefitsAndCredits, text: "Benefits & credits", iconClass: "bi-cash-stack" },
      { item: store.state.configuration.nav.guiidePlus.lumpsSumsAndTax, view: GuiidePlusView.LumpsSumsAndTax, text: "Lumps sums & tax", iconClass: "bi-plus-square" },
      { item: store.state.configuration.nav.guiidePlus.equityRelease, view: GuiidePlusView.EquityRelease, text: "Equity release", iconClass: "bi-house" },
      { item: store.state.configuration.nav.guiidePlus.partnersIncome, view: GuiidePlusView.PartnersIncome, text: "Partners income", iconClass: "bi-people" },
      { item: store.state.configuration.nav.guiidePlus.helpAndEducation, view: GuiidePlusView.HelpAndEducation, text: "Help & education", iconClass: "bi-journal-check" },
      { item: store.state.configuration.nav.guiidePlus.whyPayMore, view: GuiidePlusView.WhyPayMore, text: "Why put in more", iconClass: "bi-graph-up-arrow" },
      { item: store.state.configuration.nav.guiidePlus.otherWaysToSave, view: GuiidePlusView.OtherWaysToSave, text: "Other ways to save", iconClass: "bi-shuffle" },
      { item: store.state.configuration.nav.guiidePlus.financialCoaching, view: GuiidePlusView.FinancialCoaching, text: "Financial coaching", iconClass: "bi-mortarboard-fill" },
      { item: store.state.configuration.nav.guiidePlus.retirementChoicesHL, view: GuiidePlusView.RetirementChoicesHL, text: "Retirement choices", iconClass: "bi-signpost-split" },
      { item: store.state.configuration.nav.guiidePlus.lumpSumsHL, view: GuiidePlusView.LumpSumsHL, text: "Lump sums", iconClass: "bi-currency-pound" },
      { item: store.state.configuration.nav.guiidePlus.mixingOptionsHL, view: GuiidePlusView.MixingOptionsHL, text: "Mixing options", iconClass: "bi-puzzle" },
      { item: store.state.configuration.nav.guiidePlus.guaranteedIncomeHL, view: GuiidePlusView.GuaranteedIncomeHL, text: "Guaranteed income", iconClass: "bi-patch-check" },
      { item: store.state.configuration.nav.guiidePlus.adviserHL, view: GuiidePlusView.AdviserHL, text: "Advice", iconClass: "bi-question-square" },
      { item: store.state.configuration.nav.guiidePlus.flexibleIncomeHL, view: GuiidePlusView.FlexibleIncomeHL, text: "Flexible Income", iconClass: "bi-piggy-bank" },
    ].sort((a, b) => a.item.position - b.item.position);

    return menuItems;
});

function onItemClick(item) {
  emit("item-selected", item);
}

function onMainJourneyClick() {
  window.location.href = "/home/userhome";
}

function onUserHomeClick() {
  window.location.href = "/";
}

function getMenuLabel(standardLabel: string, customLabel: string): string {
  return !customLabel || customLabel == "" ? standardLabel : customLabel;
}
</script>

<style scoped>
.sidebar {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  /*z-index: 1040;*/
  padding: 0;
  box-shadow: inset -1px 0 0 rgb(0 0 0 / 10%);
}

.guiide-logo {
  cursor: pointer;
  width: 120px;
}

@media (min-width: 1200px) {
  .offcanvas.offcanvas-start {
    transform: translateX(0) !important;
    visibility: visible;
    width: 25% !important;
  }

  .offcanvas-header {
    visibility: hidden;
  }
}

@media (min-width: 1400px) {
  .offcanvas.offcanvas-start {
    transform: translateX(0) !important;
    visibility: visible;
    width: 16.6666666667% !important;
    background-color: red;
  }

  .offcanvas-header {
    visibility: hidden;
  }
}
</style>
